<template>
  <div id="header" class="absolute">
    <img v-if="!isMobile" id="name" :src="headerSrc" class="desktop"/>
    <img v-if="isMobile" id="name" :src="mobileHeaderSrc" class="mobile"/>
  </div>
</template>

<script>
import interact from "interactjs";

export default {
  name: "Header",
  data() {
    return {
      header: null,
      headerSrc: "",
      mobileHeaderSrc: "",
      url: process.env.VUE_APP_VPS_URL
    }
  },
  props: [
    'isMobile'
  ],
  mounted() {
    // this.enableDragDrop();
    window.console.log(this.header);
  },
  created() {
  var selfobject = this;
  this.$http.get(selfobject.url + '/homepage-header')
    .then(function (response) {
      selfobject.header = response["data"];
      selfobject.mobileHeaderSrc = selfobject.url + selfobject.header.mobile_image.formats.large.url;
      selfobject.headerSrc = selfobject.url + selfobject.header.image.url;
    })
  },
  methods: {
    enableDragDrop() {
      const header = document.getElementById('header'); 
      let x = 0;
      let y = 0;
        interact(header)
          .draggable({
            modifiers: [
              interact.modifiers.snap({
                targets: [interact.createSnapGrid({ x: 25, y: 25 })],
                range: Infinity,
                relativePoints: [{ x: 0, y: 0 }]
              }),
              interact.modifiers.restrict({
                restriction: document.getElementById('body'),
                elementRect: { top: 0, left: 0, bottom: 1, right: 1 }
              })
            ],
            inertia: true
          })
          .on("dragmove", function(event) {
            x += event.dx;
            y += event.dy;

            event.target.style.webkitTransform = event.target.style.transform =
              "translate(" + x + "px, " + y + "px)";
          });
    },
  }
}
</script>

<style>
#header {
z-index:150;
touch-action: none;
pointer-events: none;
}

img.mobile {
  position:fixed;
  width:90%;
  margin-left:5%;
  height:auto;
  margin-top:40vh;
  left:0px;
}

img.desktop {
  position:fixed;
  width:55vw;
  height:auto;
  left:20px;
  top:28px;
  /* bottom:0px; */
}

h1 {
  margin-block-start: 0px;
  margin-block-end: 0px;
  font-size:10vw;
  font-family: Prom;
}
</style>